import { getPreferences, PreferenceCategory } from '@atlassian/browser-storage-controls';

export async function canPersistOnboardingHoldoutState(): Promise<boolean> {
	try {
		const prefs = await getPreferences();

		return Boolean(prefs?.[PreferenceCategory.Functional]);
	} catch {
		return false;
	}
}
